import { render } from "./PhysicianNavMenu.vue?vue&type=template&id=3fdc1b25"
import script from "./PhysicianNavMenu.vue?vue&type=script&lang=js"
export * from "./PhysicianNavMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__